import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

// װ��ģ��״̬����
interface PackingBatchState extends ListState<any> {
    packingModel: any; // װ��ƻ�ģ�ͣ�����/�༭�ã�
    packingDetailModel: any; // װ������ģ�ͣ��༭װ�������ã�
    id: number;
}

class PackingBatchMutations extends ListMutations<any> {
}

class FrontPackingBatch extends ListModule<PackingBatchState, any, any> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
        packingModel: {} as any,
        packingDetailModel: {} as any,
        id: 0
    }

    actions = {
        // 1. ��ȡװ�������б�
        async getPackingBatchList(context: ActionContext<PackingBatchState, any>, payload: any) {
            context.state.loading = true;
            const response = await Ajax.get('/api/services/app/UserPrePlan/GetPackingBatchList', { params: payload.data });
            context.state.loading = false;
            const page = response.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },

        // 2. ����װ�䵥
        async createPack(context: ActionContext<PackingBatchState, any>, payload: any) {
            await Ajax.post('/api/services/app/UserPrePlan/CreatePack', payload.data);
        },

        // 3. �༭װ�������Ϣ
        async modifyPackPlan(context: ActionContext<PackingBatchState, any>, payload: any) {
            await Ajax.post('/api/services/app/UserPrePlan/ModifyPackPlan', payload.data);
        },

        // 4. ���װ���Ѵ���
        async processPack(context: ActionContext<PackingBatchState, any>, payload: any) {
            await Ajax.post(`/api/services/app/UserPrePlan/PorcessPack?id=${payload.data.id}`);
        },

        // 5. ����װ�����飨����/�޸�ͨ�ã�
        async savePackingDetails(context: ActionContext<PackingBatchState, any>, payload: any) {
            await Ajax.post('/api/services/app/UserPrePlan/SavePackingDetails', payload.data);
        },

        // 6. ɾ��װ��ƻ�
        async deletePackPlan(context: ActionContext<PackingBatchState, any>, payload: any) {
            await Ajax.post(`/api/services/app/UserPrePlan/DeletePackPlan?id=${payload.data.id}`);
        }
    };

    mutations = {
        setCurrentPage(state: PackingBatchState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: PackingBatchState, pagesize: number) {
            state.pageSize = pagesize;
        },
        setPackingModel(state: PackingBatchState, model: any) {
            state.packingModel = model;
        },
        setPackingDetailModel(state: PackingBatchState, model: any) {
            state.packingDetailModel = model;
        }
    }
}

const frontPackingBatch = new FrontPackingBatch();
export default frontPackingBatch;